<script context="module">
  // Place Defaults and validation in module for access from app

  // Default prefs live in src/prefsDefaults.js (shared with sign-up in Login.svelte)
  import { defaultPrefs } from "../prefsDefaults.js";
  export { defaultPrefs };

  // Select Options
  let resolutions = [
    { id: "3840x2160", text: "4K" },
    { id: "1920x1080", text: "FullHD (1920x1080)" },
    { id: "1280x720", text: "HD (1280x720)" },
    { id: "960x540", text: "qHD (960x540)" },
    { id: "640x480", text: "VGA (640x480)" },
    { id: "176x144", text: "QCIF (176x144)" },
  ];
  let yesNo = [
    { id: true, text: "Yes" },
    { id: false, text: "No" },
  ];
  let availableVideoDevices = [{ id: "auto", text: "auto" }];
  let availableAudioDevices = [{ id: "auto", text: "auto" }];
  export function validatePrefs(data) {
    let isValid = true;
    let prefs = {};
    navigator.mediaDevices.enumerateDevices().then(_gotDevices);

    let result = null;
    result = _valText(data.name, defaultPrefs.name, "name");
    prefs.name = result.value;
    if (!result.isValid) {
      isValid = false;
    }

    result = _valText(data.email, defaultPrefs.email, "email");
    prefs.email = result.value;
    if (!result.isValid) {
      isValid = false;
    }

    // // Check video source
    let videoOptions = _optionsFromSelect(availableVideoDevices);
    result = _valOptions(
      data.videoSource,
      videoOptions,
      defaultPrefs.videoSource,
      "videoSource"
    );
    prefs.videoSource = result.value;
    if (!result.isValid) {
      isValid = false;
    }

    let audioOptions = _optionsFromSelect(availableAudioDevices);
    result = _valOptions(
      data.audioSource,
      audioOptions,
      defaultPrefs.audioSource,
      "audioSource"
    );
    prefs.audioSource = result.value;
    if (!result.isValid) {
      isValid = false;
    }

    result = _valOptions(
      data.debug,
      [true, false],
      defaultPrefs.debug,
      "debug"
    );
    prefs.debug = result.value;
    if (!result.isValid) {
      isValid = false;
    }

    // forceRelay was added later; accounts without it get the default.
    result = _valOptions(
      data.forceRelay === undefined ? defaultPrefs.forceRelay : data.forceRelay,
      [true, false],
      defaultPrefs.forceRelay,
      "forceRelay"
    );
    prefs.forceRelay = result.value;
    if (!result.isValid) {
      isValid = false;
    }

    result = _valOptions(
      data.videoCodec === undefined ? defaultPrefs.videoCodec : data.videoCodec,
      ["auto", "vp9", "h264", "vp8"],
      defaultPrefs.videoCodec,
      "videoCodec"
    );
    prefs.videoCodec = result.value;
    if (!result.isValid) {
      isValid = false;
    }

    result = _valOptions(
      data.detectorPath === undefined ? defaultPrefs.detectorPath : data.detectorPath,
      ["stream", "copy", "pause"],
      defaultPrefs.detectorPath,
      "detectorPath"
    );
    prefs.detectorPath = result.value;
    if (!result.isValid) {
      isValid = false;
    }

    result = _valOptions(
      data.keepReady === undefined ? defaultPrefs.keepReady : data.keepReady,
      [true, false],
      defaultPrefs.keepReady,
      "keepReady"
    );
    prefs.keepReady = result.value;
    if (!result.isValid) {
      isValid = false;
    }

    result = _valOptions(
      data.chime === undefined ? defaultPrefs.chime : data.chime,
      [true, false],
      defaultPrefs.chime,
      "chime"
    );
    prefs.chime = result.value;
    if (!result.isValid) {
      isValid = false;
    }

    result = _valOptions(
      data.fullscreen,
      [true, false],
      defaultPrefs.fullscreen,
      "fullscreen"
    );
    prefs.fullscreen = result.value;
    if (!result.isValid) {
      isValid = false;
    }

    result = _valOptions(data.dnd, [true, false], defaultPrefs.dnd, "dnd");
    prefs.dnd = result.value;
    if (!result.isValid) {
      isValid = false;
    }

    result = _valOptions(
      data.selfView,
      [true, false],
      defaultPrefs.selfView,
      "selfView"
    );
    prefs.selfView = result.value;
    if (!result.isValid) {
      isValid = false;
    }

    result = _valNumber(
      data.minimumFaceScore,
      defaultPrefs.minimumFaceScore,
      0,
      100,
      "minimumFaceScore"
    );
    prefs.minimumFaceScore = result.value;
    if (!result.isValid) {
      isValid = false;
    }

    result = _valNumber(
      data.faceDetectionSlack,
      defaultPrefs.faceDetectionSlack,
      0,
      60000,
      "faceDetectionSlack"
    );
    prefs.faceDetectionSlack = result.value;
    if (!result.isValid) {
      isValid = false;
    }

    result = _valNumber(
      data.faceDetectionInterval,
      defaultPrefs.faceDetectionInterval,
      0,
      30000,
      "faceDetectionInterval"
    );
    prefs.faceDetectionInterval = result.value;
    if (!result.isValid) {
      isValid = false;
    }

    result = _valNumber(
      data.transmitFramerate,
      defaultPrefs.transmitFramerate,
      1,
      40,
      "transmitFrameRate"
    );
    prefs.transmitFramerate = result.value;
    if (!result.isValid) {
      isValid = false;
    }

    let resolutionOptions = _optionsFromSelect(resolutions);
    result = _valOptions(
      data.detectionResolution,
      resolutionOptions,
      defaultPrefs.detectionResolution,
      "detectionResolution"
    );
    prefs.detectionResolution = result.value;
    if (!result.isValid) {
      isValid = false;
    }

    result = _valOptions(
      data.transmitResolution,
      resolutionOptions,
      defaultPrefs.transmitResolution,
      "transmitResolution"
    );
    prefs.transmitResolution = result.value;
    if (!result.isValid) {
      isValid = false;
    }

    // result = _valText(data.peerId, defaultPrefs.peerId, "peerId");
    // prefs.peerId = result.value;
    // if (!result.isValid) {
    //   isValid = false;
    // }

    return { isValid: isValid, validatedData: prefs };
  }

  function _valText(currentValue, defaultValue, name = "") {
    let isValid = false;
    let value = defaultValue;
    if (currentValue) {
      value = currentValue;
      isValid = true;
    } else {
      console.log("validator: " + name + " is invalid: " + currentValue);
    }
    return { value: value, isValid: isValid };
  }

  function _valOptions(currentValue, options, defaultValue, name = "") {
    let isValid = false;
    let value = defaultValue;
    if (options.includes(currentValue)) {
      value = currentValue;
      isValid = true;
    } else {
      console.log("validator: " + name + " is invalid: " + currentValue);
    }
    return { value: value, isValid: isValid };
  }

  function _valNumber(currentValue, defaultValue, min, max, name = "") {
    let isValid = false;
    let value = defaultValue;
    if (currentValue >= min && currentValue <= max) {
      value = currentValue;
      isValid = true;
    } else {
      console.log("validator: " + name + " is invalid: " + currentValue);
    }
    return { value: value, isValid: isValid };
  }

  function _optionsFromSelect(selectOptions) {
    let options = [];
    var i;
    for (i = 0; i < selectOptions.length; i++) {
      options.push(selectOptions[i].id);
    }
    return options;
  }

  function _gotDevices(mediaDevices) {
    availableVideoDevices = [{ id: "auto", text: "auto" }];
    availableAudioDevices = [{ id: "auto", text: "auto" }];
    let count = 1;
    console.log(mediaDevices);
    mediaDevices.forEach((mediaDevice) => {
      if (mediaDevice.kind === "videoinput") {
        const option = document.createElement("option");
        option.value = mediaDevice.deviceId;
        const label = mediaDevice.label || `Camera ${count++}`;
        const textNode = document.createTextNode(label);
        availableVideoDevices = [
          ...availableVideoDevices,
          { id: option.value, text: label },
        ];
      } else if (mediaDevice.kind === "audioinput") {
        const option = document.createElement("option");
        option.value = mediaDevice.deviceId;
        const label = mediaDevice.label || `Audio ${count++}`;
        const textNode = document.createTextNode(label);
        availableAudioDevices = [
          ...availableAudioDevices,
          { id: option.value, text: label },
        ];
      }
    });
    console.log(availableVideoDevices);
    console.log(availableAudioDevices);
  }
</script>

<script>
  // Import SvelteFire
  import { FirebaseApp, User, Doc, Collection } from "sveltefire";

  // Import Components
  import Login from "./Login.svelte";
  import { log, announce } from "./Logging.svelte";

  // Import Svelte
  import { onMount } from "svelte";
  import { createEventDispatcher } from "svelte";

  // Component Properties
  export let firebase;
  import { saveBackground, loadBackground, clearBackground } from "../backgroundStore.js";
  import { ensureProfile } from "../profiles.js";
  export let auth;
  let saveActive = false;
  let screenBackGroundUrl = null;

  // Dispatch event to parent
  const dispatch = createEventDispatcher();

  // Config state
  let configLoaded = false;
  let configComplete = true;

  // Configuration variables with defaults
  let prefs = defaultPrefs;

  // Dispatch event to parent
  function closeConfig() {
    dispatch("modeChange", {
      action: "window",
    });
  }

  function gotToHome() {
    dispatch("modeChange", {
      action: "welcomeWindow",
    });
  }

  function goToFriends() {
    dispatch("modeChange", {
      action: "friendList",
    });
  }

  // Set form values when data loads
  function setForm(data) {
    // sveltefire emits null while the Users doc does not exist yet (a brand-new account
    // writes it a moment after auth fires); wait for the next snapshot instead of validating null.
    if (!data) return;
    console.log("before", data);
    let result = validatePrefs(data);
    console.log("setForm", result);
    prefs = result.validatedData;
    if (!result.isValid) {
      saveActive = true;
      configComplete = false;
    }
    configLoaded = true;
  }

  // The screen background never leaves this device: it is kept in the browser's
  // IndexedDB and shown from there. Nothing is uploaded.
  let backgroundPreview = null;
  let backgroundMessage = "";
  async function refreshBackgroundPreview() {
    const blob = await loadBackground();
    if (backgroundPreview) URL.revokeObjectURL(backgroundPreview);
    backgroundPreview = blob ? URL.createObjectURL(blob) : null;
  }
  refreshBackgroundPreview();
  async function backgroundOnChange(event) {
    const file = event.target.files && event.target.files[0];
    if (!file) return;
    backgroundMessage = "";
    try {
      await saveBackground(file);
      await refreshBackgroundPreview();
      backgroundMessage = "Saved on this device.";
    } catch (e) {
      backgroundMessage = e && e.message === "image larger than 5 MB"
        ? "That image is larger than 5 MB. Please choose a smaller one."
        : "Couldn't save that image on this device.";
    }
    event.target.value = "";
  }
  async function removeBackground() {
    await clearBackground();
    await refreshBackgroundPreview();
    backgroundMessage = "Background removed.";
  }

  // Delete the account. Firebase requires a recent sign-in for this, so the password
  // may be asked for again; the Cloud Function onUserDeleted then removes every
  // document, presence node and friend-list reference that belonged to the account.
  let deleteBusy = false;
  let deleteMessage = "";
  async function deleteAccount() {
    const current = auth.currentUser;
    if (!current) return;
    const ok = window.confirm(
      "Delete your PassCall account?\n\nThis removes your account, your settings, your friend list, and you from your friends' lists. It cannot be undone."
    );
    if (!ok) return;
    deleteBusy = true;
    deleteMessage = "";
    try {
      try {
        await current.delete();
      } catch (e) {
        if (e && e.code === "auth/requires-recent-login") {
          const password = window.prompt("For your security, please enter your password to delete the account:");
          if (!password) { deleteMessage = "Deletion cancelled."; return; }
          const credential = firebase.auth.EmailAuthProvider.credential(current.email, password);
          await current.reauthenticateWithCredential(credential);
          await current.delete();
        } else {
          throw e;
        }
      }
      await clearBackground();
      // onAuthStateChanged in App.svelte returns to the sign-in screen.
    } catch (e) {
      console.warn("Account deletion failed", e);
      deleteMessage = e && (e.code === "auth/wrong-password" || e.code === "auth/invalid-credential" || e.code === "auth/invalid-login-credentials")
        ? "That password was not right. The account was not deleted."
        : "Couldn't delete the account. Please try again or email help@passcall.io.";
    } finally {
      deleteBusy = false;
    }
  }

  // Update user object when form submitted
  function formSubmit(docRef) {
    console.log("setConfig");
    // screenBackground used to hold an upload URL; it now lives on the device only.
    const update = { ...prefs, screenBackground: firebase.firestore.FieldValue.delete() };
    docRef.update(update).then(function () {
      saveActive = false;
    });
    ensureProfile(firebase.firestore(), auth.currentUser, prefs.name).catch(function (e) {
      console.warn("Profile not updated", e);
    });
    configComplete = true;
  }

  // Sign out user
  function signOut() {
    auth.signOut().then(function (result) {
      console.log("Result: signOutUser:", result);
      return true;
    });
  }

  onMount(() => {
    announce("Config Mounted");
    return () => {};
  });
</script>

<FirebaseApp {firebase}>
  <User let:user>
    <Doc
      path={`Users/${user.uid}`}
      on:data={(e) => setForm(e.detail.data)}
      let:ref={docRef}
    >
      <div class="settings">
        <header class="settings__top">
          <div class="settings__bar">
            <a class="settings__brand" href="https://passcall.io/" aria-label="PassCall site">
              <img src="/images/PC-website-hd-logo.png" alt="PassCall" width="299" height="108" />
            </a>
            <nav class="settings__nav" aria-label="Account">
              {#if configComplete}
                <button type="button" on:click={gotToHome}>Home</button>
                <button type="button" on:click={goToFriends}>Friends</button>
                <button type="button" on:click|once={closeConfig}>Open the window</button>
              {/if}
              <button type="button" on:click|once={signOut}>Sign out</button>
            </nav>
          </div>
        </header>

        <main class="settings__main">
          {#if configLoaded}
            <p class="settings__eyebrow">Settings</p>
            {#if configComplete}
              <h1 class="settings__title">Make the window <em>yours.</em></h1>
              <p class="settings__lede">
                The defaults suit a laptop or small PC on a TV. Change what you like, then save. Nothing here is shared with anyone.
              </p>
            {:else}
              <h1 class="settings__title">Welcome, <em>{prefs.name || "there"}.</em></h1>
              <p class="settings__lede">
                Have a look over these settings once and press Save. You can come back any time.
              </p>
            {/if}

            <form class="settings__form" novalidate on:submit|preventDefault={formSubmit(docRef)}>
              <section class="settings__card" aria-labelledby="you-title">
                <h2 id="you-title" class="settings__card-title">You</h2>
                <div class="settings__grid">
                  <div class="settings__field">
                    <label class="settings__label" for="pref-name">Your name</label>
                    <input id="pref-name" type="text" bind:value={prefs.name} on:change={() => (saveActive = true)} required autocomplete="name" />
                    <p class="settings__help">What your friends see when a window opens with you.</p>
                  </div>
                  <div class="settings__field">
                    <label class="settings__label" for="pref-email">Email</label>
                    <input id="pref-email" type="email" bind:value={prefs.email} on:change={() => (saveActive = true)} required autocomplete="email" />
                    <p class="settings__help">The address friends use to add you.</p>
                  </div>
                </div>
              </section>

              <section class="settings__card" aria-labelledby="window-title">
                <h2 id="window-title" class="settings__card-title">Your window</h2>
                <div class="settings__grid">
                  <div class="settings__field">
                    <label class="settings__label" for="pref-dnd">Do not disturb</label>
                    <select id="pref-dnd" bind:value={prefs.dnd} on:blur={() => (saveActive = true)} on:change={() => (saveActive = true)}>
                      {#each yesNo as choice}<option value={choice.id}>{choice.text}</option>{/each}
                    </select>
                    <p class="settings__help">Yes keeps your window closed and stops you appearing to friends, without signing out.</p>
                  </div>
                  <div class="settings__field">
                    <label class="settings__label" for="pref-ready">Keep windows ready</label>
                    <select id="pref-ready" bind:value={prefs.keepReady} on:blur={() => (saveActive = true)} on:change={() => (saveActive = true)}>
                      {#each yesNo as choice}<option value={choice.id}>{choice.text}</option>{/each}
                    </select>
                    <p class="settings__help">Yes keeps a quiet connection to friends who are online, so a window opens the instant you are both seen. Nothing is sent until your own camera sees someone. No turns this off; windows then take a few seconds to open.</p>
                  </div>
                  <div class="settings__field">
                    <label class="settings__label" for="pref-chime">Chime when a window opens</label>
                    <select id="pref-chime" bind:value={prefs.chime} on:blur={() => (saveActive = true)} on:change={() => (saveActive = true)}>
                      {#each yesNo as choice}<option value={choice.id}>{choice.text}</option>{/each}
                    </select>
                  </div>
                  <div class="settings__field">
                    <label class="settings__label" for="pref-fullscreen">Full screen</label>
                    <select id="pref-fullscreen" bind:value={prefs.fullscreen} on:blur={() => (saveActive = true)} on:change={() => (saveActive = true)}>
                      {#each yesNo as choice}<option value={choice.id}>{choice.text}</option>{/each}
                    </select>
                  </div>
                  <div class="settings__field">
                    <label class="settings__label" for="pref-selfview">Camera preview</label>
                    <select id="pref-selfview" bind:value={prefs.selfView} on:blur={() => (saveActive = true)} on:change={() => (saveActive = true)}>
                      {#each yesNo as choice}<option value={choice.id}>{choice.text}</option>{/each}
                    </select>
                    <p class="settings__help">Shows a small picture of your own camera in the corner.</p>
                  </div>
                </div>
                <div class="settings__field settings__field--wide">
                  <label class="settings__label" for="screen-background">Screen background</label>
                  <p class="settings__help">Shown while no window is open. Kept in this browser only, never uploaded. Up to 5 MB.</p>
                  <div class="settings__bg">
                    {#if backgroundPreview}
                      <img class="settings__bg-preview" src={backgroundPreview} alt="" />
                    {/if}
                    <label class="settings__file">
                      <input id="screen-background" type="file" accept="image/*" on:change={backgroundOnChange} />
                      <span>{backgroundPreview ? "Choose a different image" : "Choose an image"}</span>
                    </label>
                    {#if backgroundPreview}
                      <button type="button" class="settings__btn settings__btn--ghost" on:click={removeBackground}>Remove</button>
                    {/if}
                  </div>
                  {#if backgroundMessage}<p class="settings__note settings__note--ok">{backgroundMessage}</p>{/if}
                </div>
              </section>

              <section class="settings__card" aria-labelledby="camera-title">
                <h2 id="camera-title" class="settings__card-title">Camera and sound</h2>
                <div class="settings__grid">
                  <div class="settings__field">
                    <label class="settings__label" for="pref-video">Camera</label>
                    <select id="pref-video" bind:value={prefs.videoSource} on:blur={() => (saveActive = true)} on:change={() => (saveActive = true)}>
                      {#each availableVideoDevices as choice}<option value={choice.id}>{choice.text}</option>{/each}
                    </select>
                  </div>
                  <div class="settings__field">
                    <label class="settings__label" for="pref-audio">Microphone</label>
                    <select id="pref-audio" bind:value={prefs.audioSource} on:blur={() => (saveActive = true)} on:change={() => (saveActive = true)}>
                      {#each availableAudioDevices as choice}<option value={choice.id}>{choice.text}</option>{/each}
                    </select>
                  </div>
                  <div class="settings__field">
                    <label class="settings__label" for="pref-resolution">Picture you send</label>
                    <select id="pref-resolution" bind:value={prefs.transmitResolution} on:blur={() => (saveActive = true)} on:change={() => (saveActive = true)}>
                      {#each resolutions as choice}<option value={choice.id}>{choice.text}</option>{/each}
                    </select>
                    <p class="settings__help">720p is right for most screens and keeps the picture smooth.</p>
                  </div>
                  <div class="settings__field">
                    <label class="settings__label" for="pref-fps">Frames per second</label>
                    <input id="pref-fps" type="number" min="5" max="60" step="1" bind:value={prefs.transmitFramerate} on:change={() => (saveActive = true)} />
                  </div>
                </div>
              </section>

              <details class="settings__card settings__card--details">
                <summary class="settings__card-title settings__summary">Advanced: face detection</summary>
                <p class="settings__help settings__help--lead">How the camera decides that someone is in front of the screen. The defaults work well; change these only if a face is missed or seen when nobody is there.</p>
                <div class="settings__grid">
                  <div class="settings__field">
                    <label class="settings__label" for="pref-score">Minimum confidence (%)</label>
                    <input id="pref-score" type="number" min="0" max="100" step="1" bind:value={prefs.minimumFaceScore} on:change={() => (saveActive = true)} />
                  </div>
                  <div class="settings__field">
                    <label class="settings__label" for="pref-slack">Keep available after a face is lost (ms)</label>
                    <input id="pref-slack" type="number" min="1000" step="any" bind:value={prefs.faceDetectionSlack} on:change={() => (saveActive = true)} />
                  </div>
                  <div class="settings__field">
                    <label class="settings__label" for="pref-interval">Check every (ms)</label>
                    <input id="pref-interval" type="number" min="250" step="any" bind:value={prefs.faceDetectionInterval} on:change={() => (saveActive = true)} />
                  </div>
                  <div class="settings__field">
                    <label class="settings__label" for="pref-detres">Detection picture size</label>
                    <select id="pref-detres" bind:value={prefs.detectionResolution} on:blur={() => (saveActive = true)} on:change={() => (saveActive = true)}>
                      {#each resolutions as choice}<option value={choice.id}>{choice.text}</option>{/each}
                    </select>
                  </div>
                </div>
              </details>

              <details class="settings__card settings__card--details">
                <summary class="settings__card-title settings__summary">Advanced: testing tools</summary>
                <div class="settings__grid">
                  <div class="settings__field">
                    <label class="settings__label" for="pref-debug">Show stats and buttons on the window</label>
                    <select id="pref-debug" bind:value={prefs.debug} on:blur={() => (saveActive = true)} on:change={() => (saveActive = true)}>
                      {#each yesNo as choice}<option value={choice.id}>{choice.text}</option>{/each}
                    </select>
                  </div>
                  <div class="settings__field">
                    <label class="settings__label" for="pref-relay">Force relay (TURN only)</label>
                    <select id="pref-relay" bind:value={prefs.forceRelay} on:blur={() => (saveActive = true)} on:change={() => (saveActive = true)}>
                      {#each yesNo as choice}<option value={choice.id}>{choice.text}</option>{/each}
                    </select>
                    <p class="settings__help">Yes ignores direct routes and goes through the relay, as a call between two different networks would.</p>
                  </div>
                  <div class="settings__field">
                    <label class="settings__label" for="pref-codec">Video codec</label>
                    <select id="pref-codec" bind:value={prefs.videoCodec} on:blur={() => (saveActive = true)} on:change={() => (saveActive = true)}>
                      <option value="auto">Automatic (VP9 first)</option>
                      <option value="vp8">VP8 (software everywhere)</option>
                      <option value="h264">H.264</option>
                      <option value="vp9">VP9</option>
                    </select>
                    <p class="settings__help">Try VP8 if a device shows flashing or torn frames. Set the same choice on both accounts; the answering side decides.</p>
                  </div>
                  <div class="settings__field">
                    <label class="settings__label" for="pref-detector">Detector camera access</label>
                    <select id="pref-detector" bind:value={prefs.detectorPath} on:blur={() => (saveActive = true)} on:change={() => (saveActive = true)}>
                      <option value="stream">Frame stream to detector (default)</option>
                      <option value="copy">Copy a frame from the preview each check</option>
                      <option value="pause">Pause the detector while a window is open</option>
                    </select>
                    <p class="settings__help">For tracking down flashing frames on a device. "Pause" assumes you are still there for as long as the window is open.</p>
                  </div>
                </div>
              </details>

              <div class="settings__actions">
                <button id="saveConfigBtn" class="settings__btn settings__btn--save" type="submit" disabled={!saveActive}>Save</button>
                {#if saveActive}<span class="settings__hint">Unsaved changes</span>{:else if configComplete}<span class="settings__hint">Saved</span>{/if}
              </div>
            </form>

            <section class="settings__card" aria-labelledby="safety-title">
              <h2 id="safety-title" class="settings__card-title">Safety</h2>
              <p class="settings__help settings__help--lead">
                Seen something that worries you, or a person who should not be on PassCall? Tell us. A person reads every report. If a child is in danger now, call your local emergency number first.
              </p>
              <a class="settings__btn settings__btn--link" href={"mailto:help@passcall.io?subject=" + encodeURIComponent("Concern about PassCall") + "&body=" + encodeURIComponent("Reporting from account: " + ((auth && auth.currentUser && auth.currentUser.email) || "") + "\n\nWhat happened:\n")}>Report a concern</a>
              <p class="settings__help">Our <a href="https://passcall.io/child-safety/" target="_blank" rel="noopener">child safety standards</a> say what we do with a report.</p>
            </section>

            <section class="settings__card settings__card--danger" aria-labelledby="delete-title">
              <h2 id="delete-title" class="settings__card-title">Delete your account</h2>
              <p class="settings__help settings__help--lead">
                Removes your account, your settings, your friend list, and you from your friends' lists. Nothing about you stays on our servers. This cannot be undone.
              </p>
              <button type="button" class="settings__btn settings__btn--danger" on:click={deleteAccount} disabled={deleteBusy}>Delete my account</button>
              {#if deleteMessage}<p class="settings__note settings__note--error">{deleteMessage}</p>{/if}
            </section>
          {:else}
            <p class="settings__eyebrow">Settings</p>
            <p class="settings__lede">Loading…</p>
          {/if}
        </main>

        <footer class="settings__foot">
          <span>PassCall</span>
          <a href="https://passcall.io/privacy/">Privacy</a>
          <a href="mailto:help@passcall.io">help@passcall.io</a>
        </footer>
      </div>
    </Doc>
    <div slot="signed-out">
      <Login />
    </div>
  </User>
</FirebaseApp>

<style>
  .settings { min-height: 100vh; display: flex; flex-direction: column; font-family: var(--font); color: var(--on-dark);
    background: radial-gradient(70% 55% at 10% 0%, rgba(31, 107, 63, .58), transparent 65%), radial-gradient(45% 45% at 92% 70%, rgba(212, 175, 55, .2), transparent 65%), var(--ink); }
  .settings__top { background: var(--wood); border-bottom: 2px solid var(--wood-trim); box-shadow: 0 6px 18px rgba(0, 0, 0, .35); }
  .settings__bar { max-width: 1200px; margin: 0 auto; padding: 0 16px; min-height: 68px; display: flex; align-items: center; gap: 1.5rem; }
  .settings__brand img { height: 34px; width: auto; filter: brightness(0) invert(1); display: block; }
  .settings__nav { margin-left: auto; display: flex; gap: .5rem; flex-wrap: wrap; }
  .settings__nav button { font: inherit; font-weight: 500; font-size: .95rem; padding: .5rem .9rem; border-radius: 999px; border: 1.5px solid rgba(244, 237, 227, .35); background: transparent; color: var(--on-dark); cursor: pointer; }
  .settings__nav button:hover { background: var(--on-dark); color: var(--ink); }

  .settings__main { flex: 1; max-width: 1200px; width: 100%; margin: 0 auto; padding: clamp(2.5rem, 7vw, 5rem) 16px; }
  .settings__eyebrow { margin: 0 0 1rem; font-size: .78rem; font-weight: 600; letter-spacing: .14em; text-transform: uppercase; color: var(--amber); display: inline-flex; align-items: center; gap: .5rem; }
  .settings__eyebrow::before { content: ""; width: 8px; height: 8px; border-radius: 50%; background: currentColor; }
  .settings__title { font-family: var(--display); font-weight: 500; font-size: clamp(2.2rem, 4vw + .5rem, 3.6rem); line-height: 1.05; letter-spacing: -.025em; margin: 0 0 1rem; max-width: 18ch; }
  .settings__title em { background: var(--gold-metal); -webkit-background-clip: text; background-clip: text; color: transparent; font-style: italic; }
  .settings__lede { margin: 0 0 2rem; max-width: 52ch; font-size: 1.1rem; line-height: 1.5; color: var(--on-dark-muted); }

  .settings__form { display: flex; flex-direction: column; gap: 1.25rem; max-width: 760px; }
  .settings__card { max-width: 760px; padding: 1.75rem; border-radius: 18px; background: var(--paper); color: var(--ink); box-shadow: 0 24px 60px rgba(0, 0, 0, .35); }
  .settings__card-title { font-family: var(--display); font-weight: 500; font-size: 1.5rem; margin: 0 0 1rem; }
  .settings__card--details { padding: 0; }
  .settings__card--details > *:not(summary) { margin-left: 1.75rem; margin-right: 1.75rem; }
  .settings__card--details > .settings__grid { margin-bottom: 1.75rem; }
  .settings__summary { padding: 1.25rem 1.75rem; cursor: pointer; list-style: none; display: flex; align-items: center; justify-content: space-between; }
  .settings__summary::-webkit-details-marker { display: none; }
  .settings__summary::after { content: "+"; font-family: var(--font); font-size: 1.4rem; color: #6b625b; }
  details[open] > .settings__summary::after { content: "–"; }
  details[open] > .settings__summary { margin-bottom: .25rem; }

  .settings__grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(260px, 1fr)); gap: 1rem 1.5rem; }
  .settings__field { display: flex; flex-direction: column; min-width: 0; }
  .settings__field--wide { margin-top: 1.25rem; }
  .settings__label { font-size: .9rem; font-weight: 600; margin-bottom: .4rem; }
  .settings__field input, .settings__field select { font: inherit; font-size: 1rem; padding: .75rem 1rem; border-radius: 12px; border: 1.5px solid var(--sand); background: #fff; color: var(--ink); width: 100%; box-sizing: border-box; }
  .settings__field select { appearance: none; -webkit-appearance: none; background-image: linear-gradient(45deg, transparent 50%, #6b625b 50%), linear-gradient(135deg, #6b625b 50%, transparent 50%); background-position: calc(100% - 20px) 55%, calc(100% - 14px) 55%; background-size: 6px 6px; background-repeat: no-repeat; padding-right: 2.5rem; }
  .settings__field input:focus, .settings__field select:focus { outline: 2px solid var(--red); outline-offset: 1px; border-color: var(--red); }
  .settings__help { margin: .4rem 0 0; font-size: .875rem; line-height: 1.45; color: #6b625b; }
  .settings__help--lead { margin: 0 0 1rem; font-size: .95rem; }

  .settings__bg { display: flex; align-items: center; gap: .75rem; flex-wrap: wrap; margin-top: .75rem; }
  .settings__bg-preview { height: 72px; width: 128px; object-fit: cover; border-radius: 10px; border: 1px solid var(--sand); }
  .settings__file { position: relative; display: inline-block; }
  .settings__file input { position: absolute; inset: 0; opacity: 0; width: 100%; height: 100%; cursor: pointer; }
  .settings__file span { display: inline-block; font-weight: 600; font-size: .95rem; padding: .6rem 1.1rem; border-radius: 999px; border: 1.5px solid var(--sand); background: transparent; color: var(--ink); }
  .settings__file:hover span { background: var(--cream); border-color: var(--ink); }

  .settings__btn { font: inherit; font-weight: 600; font-size: 1rem; padding: .8rem 1.4rem; border: 0; border-radius: 999px; background: var(--gold-metal); color: var(--ink); cursor: pointer; transition: filter .15s; }
  .settings__btn:hover:not(:disabled) { filter: brightness(1.06); }
  .settings__btn:disabled { opacity: .55; cursor: default; }
  .settings__btn--ghost { background: transparent; color: var(--ink); border: 1.5px solid var(--sand); font-size: .95rem; padding: .6rem 1.1rem; }
  .settings__btn--ghost:hover:not(:disabled) { background: var(--cream); border-color: var(--ink); }
  .settings__btn--save { background: var(--ink); color: var(--on-dark); }
  .settings__btn--save:hover:not(:disabled) { background: var(--ink-3); }
  .settings__btn--link { display: inline-block; text-decoration: none; background: transparent; color: var(--ink); border: 1.5px solid var(--ink); }
  .settings__btn--link:hover { background: var(--ink); color: #fff; }
  .settings__btn--danger { background: transparent; color: var(--danger); border: 1.5px solid var(--danger); }
  .settings__btn--danger:hover:not(:disabled) { background: var(--danger); color: #fff; }
  .settings__actions { display: flex; align-items: center; gap: 1rem; flex-wrap: wrap; }
  .settings__hint { font-size: .9rem; color: var(--on-dark-muted); }
  .settings__card--danger { margin-top: 2rem; background: rgba(255, 252, 247, .92); }
  .settings__note { margin: .85rem 0 0; padding: .7rem .9rem; border-radius: 10px; font-size: .95rem; }
  .settings__note--error { background: rgba(158, 42, 43, .1); color: var(--danger); }
  .settings__note--ok { background: rgba(91, 208, 138, .18); color: #1f6b3f; }

  .settings__foot { border-top: 1px solid var(--line-dark); color: var(--on-dark-muted); font-size: .875rem; padding: 1.25rem 16px; display: flex; flex-wrap: wrap; justify-content: center; gap: .5rem 2rem; }
  .settings__foot a { color: var(--on-dark); text-decoration: none; }
</style>
